<template>
    <div class="row justify-content-center text-center" v-if="links && links.totalPages > 0">
        <div class="col">
            <nav aria-label="...">
                <ul class="pagination justify-content-center ">
                    <li :class="links.currentPage === 1?'page-item disabled':'page-item'">
                        <button class="page-link" @click="goPage(1)" tabindex="-1" aria-disabled="true">Primera
                        </button>
                    </li>
                    <li :class="links.currentPage === 1?'page-item disabled':'page-item'">
                        <button class="page-link" @click="goPage(links.currentPage - 1)" tabindex="-1" aria-disabled="true">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                        </button>
                    </li>
                    <li :class="page === links.currentPage?'page-item active':'page-item'" v-for="page in pages" :key="page.id">
                        <button class="page-link" @click="goPage(page)">{{page}}</button>
                    </li>
                    <li :class="links.currentPage === links.totalPages?'page-item disabled':'page-item'">
                        <button class="page-link" @click="goPage(links.currentPage + 1)" aria-label="Next">
                            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                        </button>
                    </li>
                    <li :class="links.currentPage === links.totalPages?'page-item disabled':'page-item'">
                        <button class="page-link" @click="goPage(links.totalPages)">Última</button>
                    </li>
                </ul>
            </nav>
            <div class="row justify-content-center">
                <div class="col-sm-4 col-md-2 text-dark ">
                    Ver de
                    <select class="text-dark" :options="links.sizeOptions" v-model="links.size" @change="changeSize">
                        <option v-for="option in links.sizeOptions" :key="option.id">{{option}}</option>
                    </select>
                    Registros
                </div>
            </div>

            <div class="text-primary mt-2"><strong>Página {{links.currentPage}} de {{links.totalPages}}</strong></div>
            <small class="text-secondary"><strong>Total Registros: {{links.totalItems}}</strong></small>
        </div>
    </div>

</template>

<script>
    import {getUrlQuery} from "../helper/queryHelper";
    export default {
        props: ['links'],
        data() {
            return {
                getUrlQuery
            }
        },
        methods: {
            goPage(page) {
                this.$router.push(this.$route.path + '?'+
                    this.getUrlQuery(['currentPage'])
                    +'&currentPage=' + page)
            },
            changeSize(){
                this.$router.push(this.$route.path + '?'+
                    this.getUrlQuery(['size']) + '&size='+this.links.size)
            }
        },
        computed: {
            pages() {
                let list = []
                if (this.links) {
                    let i = this.links.currentPage - 3 > 0 ? this.links.currentPage - 3 : 1
                    let max = this.links.currentPage + 3 < this.links.totalPages ? this.links.currentPage + 3 :
                        this.links.totalPages
                    for (i; i <= max; i++)
                        list.push(i)
                } else {
                    list.push(1)
                }
                return list
            }
        }
    }    
</script>